import { callExternalApi, CallResult } from '../callExternalApi';
import {
  AssetFieldMapping,
  AssetMigrationValidationResponse,
  AssetMigrationResult
} from '../../store/OutsideInventory';

const serializeFieldMappings = (fieldMappings: AssetFieldMapping[]): string =>
  JSON.stringify(fieldMappings.map((m) => ({ asset_field: m.assetFieldKey, oi_field: m.portalFieldKey })));

export const validateAssetMigration = (
  file: File,
  fieldMappings: AssetFieldMapping[]
): Promise<CallResult<AssetMigrationValidationResponse>> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('field_mappings', serializeFieldMappings(fieldMappings));

  return callExternalApi<AssetMigrationValidationResponse>({
    url: 'api/outside_inventory/asset_migration/validate',
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data'
    },
    data: formData
  });
};

export const migrateAssets = (
  assetIds: string[],
  fieldMappings: AssetFieldMapping[]
): Promise<CallResult<AssetMigrationResult>> => {
  return callExternalApi<AssetMigrationResult>({
    url: 'api/outside_inventory/asset_migration/migrate',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: {
      asset_ids: assetIds,
      field_mappings: serializeFieldMappings(fieldMappings)
    }
  });
};
